// extracted by mini-css-extract-plugin
export default {"select":"style_select__Vo5aa","input":"style_input__oZNBH"};